export const SELECT_ORG_TYPE = "SELECT ORG TYPE"
export const ORG_DETAILS_FORM_INSTALLER = "ORG DETAILS FORM INSTALLER"
export const ORG_DETAILS_FORM_MANU = "ORG DETAILS FORM SOFTWARE MANU"
export const EXISTING_DEVICES_CHECK = "EXISTING DEVICES CHECK"
export const HAS_EXISTING_DEVICES = "HAS EXISTING DEVICES"
export const SOFTWARE_PROVIDER_SETUP = "SOFTWARE PROVIDER SETUP"
export const EXPECTING_INVITE = "EXPECTING INVITE"
export const MFA = "MFA"
export const ORG_SET_UP_SUCCESS = "ORG SET UP SUCCESS"
export const INVITE_REVIEW = "INVITE REVIEW"
export const INVITE_ARE_YOU_SURE = "INVITE ARE YOU SURE"
export const INVITE_ACCEPTED_SUCCESS = "INVITE ACCEPTED SUCCESS"

export type FirstLoginDispatcherKeys =
    | typeof SELECT_ORG_TYPE
    | typeof ORG_DETAILS_FORM_INSTALLER
    | typeof ORG_DETAILS_FORM_MANU
    | typeof EXISTING_DEVICES_CHECK
    | typeof HAS_EXISTING_DEVICES
    | typeof SOFTWARE_PROVIDER_SETUP
    | typeof EXPECTING_INVITE
    | typeof MFA
    | typeof ORG_SET_UP_SUCCESS
    | typeof INVITE_REVIEW
    | typeof INVITE_ARE_YOU_SURE
    | typeof INVITE_ACCEPTED_SUCCESS

export const FIRST_LOGIN_INITIAL = SELECT_ORG_TYPE
export const INVITE_INITIAL = INVITE_REVIEW
